// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Suade workspace — Office-native (Fluent 2) design system, light theme.
   Bespoke, dependency-free. All component styling flows from these tokens.
   ========================================================================== */
:root {
  /* neutrals (Fluent warm-gray bias) */
  --canvas: #faf9f8;
  --surface: #ffffff;
  --surface-alt: #f7f6f4;
  --surface-sunken: #f3f2f1;
  --hair: #edebe9;
  --border: #e1dfdd;
  --border-strong: #d2d0ce;
  --ink: #242424;
  --ink-2: #605e5c;
  --ink-3: #8a8886;
  --ink-disabled: #a19f9d;
  /* accent — communication blue */
  --accent: #0f6cbd;
  --accent-hover: #115ea3;
  --accent-pressed: #0c3b5e;
  --accent-tint: #eff6fc;
  --accent-tint-2: #e5f1fb;
  /* semantics */
  --success: #0e700e;
  --success-bg: #dff6dd;
  --warning: #9d5d00;
  --warning-bg: #fff4ce;
  --warning-border: #f6e8b8;
  --danger: #c50f1f;
  --danger-bg: #fde7e9;
  --danger-border: #f3d0d4;
  /* elevation */
  --depth-2: 0 0.6px 1.8px rgba(0, 0, 0, 0.1), 0 0.1px 0.5px rgba(0, 0, 0, 0.08);
  --depth-4: 0 1.6px 3.6px rgba(0, 0, 0, 0.13), 0 0.3px 0.9px rgba(0, 0, 0, 0.1);
  --depth-8: 0 3.2px 7.2px rgba(0, 0, 0, 0.13), 0 0.6px 1.8px rgba(0, 0, 0, 0.11);
  --depth-16: 0 6.4px 14.4px rgba(0, 0, 0, 0.13), 0 1.2px 3.6px rgba(0, 0, 0, 0.11);
  /* type + shape */
  --font: "Segoe UI Variable Text", "Segoe UI", -apple-system, BlinkMacSystemFont, system-ui, Roboto,
    "Helvetica Neue", sans-serif;
  --r: 4px;
  --r-lg: 8px;
}

* {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
}
body {
  background: var(--canvas);
  color: var(--ink);
  font-family: var(--font);
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
  border-radius: 2px;
}
::selection {
  background: var(--accent-tint-2);
}

/* ---- App shell / command bar ----------------------------------------- */
.appbar {
  position: sticky;
  top: 0;
  z-index: 20;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: var(--surface);
  border-bottom: 1px solid var(--hair);
}
.appbar-l {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.brand {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--ink);
  white-space: nowrap;
}
.brand .dot {
  color: var(--accent);
}
.matter-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 28px;
  padding: 0 12px;
  max-width: 46vw;
  background: var(--accent-tint);
  color: var(--accent-pressed);
  border: 1px solid var(--accent-tint-2);
  border-radius: 14px;
  font-size: 12.5px;
  font-weight: 600;
}
.matter-chip .txt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.appbar-r {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ink-2);
  font-size: 13px;
}
.appbar-r .who {
  max-width: 22vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iconbtn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: var(--r);
  background: transparent;
  color: var(--ink-2);
  display: grid;
  place-items: center;
  cursor: pointer;
}
.iconbtn:hover {
  background: var(--surface-alt);
}
.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex: none;
  background: var(--accent);
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.link-btn {
  border: none;
  background: none;
  color: var(--ink-2);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: var(--r);
}
.link-btn:hover {
  background: var(--surface-alt);
  color: var(--ink);
}

.workspace {
  max-width: 940px;
  margin: 0 auto;
  padding: 24px 24px 80px;
}

/* ---- Step rail ------------------------------------------------------- */
.steprail {
  display: flex;
  align-items: center;
  margin: 4px 0 22px;
}
.step {
  display: flex;
  align-items: center;
  gap: 10px;
}
.step .num {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex: none;
  display: grid;
  place-items: center;
  font-size: 12.5px;
  font-weight: 600;
  background: var(--surface);
  border: 1.5px solid var(--border-strong);
  color: var(--ink-3);
}
.step .lbl {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-3);
}
.step.done .num {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}
.step.done .lbl {
  color: var(--ink-2);
}
.step.active .num {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--accent-tint);
}
.step.active .lbl {
  color: var(--ink);
}
.step-sep {
  flex: 1;
  height: 1.5px;
  min-width: 20px;
  background: var(--hair);
  margin: 0 14px;
}
.step-sep.done {
  background: var(--accent);
}

/* ---- Cards ----------------------------------------------------------- */
.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--depth-4);
  padding: 22px 24px;
  margin-bottom: 16px;
  animation: rise 0.22s ease both;
}
@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
}
.card h2 {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.01em;
  margin: 0 0 2px;
}
.card .sub {
  margin: 0 0 18px;
  color: var(--ink-2);
  font-size: 14px;
  line-height: 1.5;
}

/* ---- Pivot tabs ------------------------------------------------------ */
.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--hair);
  margin-bottom: 20px;
}
.tab {
  position: relative;
  border: none;
  background: none;
  padding: 10px 12px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink-2);
  cursor: pointer;
}
.tab:hover {
  color: var(--ink);
}
.tab.active {
  color: var(--accent);
}
.tab.active::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: -1px;
  height: 2px;
  border-radius: 2px;
  background: var(--accent);
}

/* ---- Fields ---------------------------------------------------------- */
label.field {
  display: block;
  margin-bottom: 16px;
}
label.field .lbl {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 6px;
}
label.field .hint {
  font-weight: 400;
  color: var(--ink-3);
}
input[type="text"],
select,
textarea {
  width: 100%;
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--border-strong);
  border-radius: var(--r);
  font: inherit;
  font-size: 14px;
  color: var(--ink);
  background: var(--surface);
  transition: border-color 0.15s, box-shadow 0.15s;
}
textarea {
  height: auto;
  min-height: 78px;
  padding: 8px 10px;
  line-height: 1.5;
  resize: vertical;
}
input[type="text"]::placeholder,
textarea::placeholder {
  color: var(--ink-3);
}
input[type="text"]:hover,
select:hover,
textarea:hover {
  border-color: var(--ink-3);
}
input[type="text"]:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent);
}
.select-wrap {
  position: relative;
}
.select-wrap select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 32px;
}
.select-wrap .chev {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--ink-2);
  pointer-events: none;
}
.inline-field {
  display: flex;
  gap: 10px;
  align-items: stretch;
}

/* ---- Buttons --------------------------------------------------------- */
.btn {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 32px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: var(--r);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.btn.lg {
  height: 38px;
  padding: 0 20px;
  font-size: 15px;
}
.btn.primary {
  background: var(--accent);
  color: #fff;
}
.btn.primary:hover {
  background: var(--accent-hover);
}
.btn.primary:active {
  background: var(--accent-pressed);
}
.btn.secondary {
  background: var(--surface);
  color: var(--ink);
  border-color: var(--border-strong);
}
.btn.secondary:hover {
  background: var(--surface-alt);
}
.btn.subtle {
  background: transparent;
  color: var(--accent);
}
.btn.subtle:hover {
  background: var(--accent-tint);
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 22px;
}

/* ---- Banners --------------------------------------------------------- */
.banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--r);
  font-size: 13px;
  line-height: 1.45;
  border: 1px solid;
}
.banner svg {
  flex: none;
}
.banner.info {
  background: var(--accent-tint);
  border-color: var(--accent-tint-2);
  color: var(--accent-pressed);
}
.banner.warn {
  background: var(--warning-bg);
  border-color: var(--warning-border);
  color: var(--warning);
}
.banner.error {
  background: var(--danger-bg);
  border-color: var(--danger-border);
  color: var(--danger);
}
.error-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--r);
  font-size: 13px;
  color: var(--danger);
  background: var(--danger-bg);
  border: 1px solid var(--danger-border);
  margin-top: 14px;
}

/* ---- Dropzone -------------------------------------------------------- */
.dropzone {
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--r-lg);
  padding: 26px;
  text-align: center;
  color: var(--ink-2);
  font-size: 14px;
  background: var(--surface-alt);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.dropzone:hover {
  border-color: var(--ink-3);
}
.dropzone.drag {
  border-color: var(--accent);
  background: var(--accent-tint);
}
.dropzone .dz-icon {
  color: var(--accent);
  margin-bottom: 8px;
}
.dropzone strong {
  color: var(--accent);
  font-weight: 600;
}
.dropzone .dz-sub {
  font-size: 12px;
  color: var(--ink-3);
  margin-top: 6px;
}
.dropzone .dz-busy {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--ink-2);
}

/* ---- Classification summary ------------------------------------------ */
.matter-facts {
  font-size: 13.5px;
  color: var(--ink-2);
  line-height: 1.5;
  margin: 4px 0 12px;
}
.matter-facts b {
  color: var(--ink);
  font-weight: 600;
}
.summary-line {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  margin: 14px 0 10px;
}
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chip {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 5px 11px;
  border-radius: 6px;
  background: var(--accent-tint);
  color: var(--accent-pressed);
  border: 1px solid var(--accent-tint-2);
  font-size: 12.5px;
  font-weight: 500;
}
.chip b {
  font-size: 13.5px;
  font-weight: 600;
}
.filelist {
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  overflow: hidden;
}
.filelist li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  font-size: 13px;
  color: var(--ink);
}
.filelist li + li {
  border-top: 1px solid var(--hair);
}
.filelist .fl-icon {
  color: var(--ink-3);
  flex: none;
}
.filelist .fl-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filelist .cat {
  color: var(--ink-2);
  font-size: 12px;
  text-transform: capitalize;
  background: var(--surface-sunken);
  padding: 2px 8px;
  border-radius: 10px;
}
.note {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12.5px;
  color: var(--warning);
  background: var(--warning-bg);
  border: 1px solid var(--warning-border);
  border-radius: var(--r);
  padding: 9px 12px;
  margin-top: 12px;
}
.note svg {
  flex: none;
}

/* ---- Provenance graph ------------------------------------------------ */
.provenance {
  border: 1px solid var(--hair);
  border-radius: var(--r-lg);
  background: linear-gradient(180deg, #fdfdfc, var(--surface));
  padding: 18px 20px 16px;
  margin: 6px 0 8px;
}
.prov-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-bottom: 16px;
}
.prov-title {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent-pressed);
}
.prov-stats {
  font-size: 12.5px;
  color: var(--ink-2);
}
.prov-stats b {
  color: var(--ink);
  font-weight: 600;
}
.prov-rail {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 2px 6px;
  overflow-x: auto;
}
.prov-rail::before {
  content: "";
  position: absolute;
  left: 4px;
  right: 4px;
  top: 11px;
  height: 2px;
  background: var(--border-strong);
  z-index: 0;
}
.rail-node {
  position: relative;
  z-index: 1;
  flex: none;
}
.rail-dot {
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--surface);
  border: 2px solid var(--border-strong);
  transition: border-color 0.15s, background 0.15s, transform 0.15s;
}
.rail-node:hover .rail-dot {
  border-color: var(--accent);
  transform: scale(1.25);
}
.rail-node.first .rail-dot {
  background: var(--accent);
  border-color: var(--accent);
}
.rail-node.done .rail-dot {
  background: var(--success);
  border-color: var(--success);
}
.rail-node.running .rail-dot {
  background: var(--accent);
  border-color: var(--accent);
  box-shadow: 0 0 0 4px var(--accent-tint);
  animation: pulse 1.3s ease-in-out infinite;
}
.rail-node.skipped .rail-dot {
  border-style: dashed;
}
.rail-node.error .rail-dot {
  background: var(--danger);
  border-color: var(--danger);
}
.rail-tip {
  position: absolute;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  white-space: nowrap;
  background: var(--ink);
  color: #fff;
  font-size: 11.5px;
  padding: 4px 8px;
  border-radius: var(--r);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s, transform 0.15s;
  z-index: 5;
  box-shadow: var(--depth-8);
}
.rail-node:hover .rail-tip {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.rail-arrow {
  color: var(--ink-3);
  z-index: 1;
  flex: none;
  display: inline-flex;
}
.rail-out {
  z-index: 1;
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: var(--surface-sunken);
  border: 1px solid var(--border);
  border-radius: var(--r);
  padding: 6px 12px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--ink-2);
  line-height: 1.35;
}
.prov-join {
  width: 2px;
  height: 14px;
  background: var(--border-strong);
  margin: 2px 0 0 24px;
}
.prov-refs {
  border: 1px dashed var(--border-strong);
  border-radius: var(--r-lg);
  padding: 12px 14px;
  background: #fbfcfd;
}
.refs-label {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--ink-2);
  margin-bottom: 10px;
}
.refs-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.refchip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12.5px;
  color: var(--ink);
  cursor: default;
  transition: border-color 0.15s, background 0.15s;
}
.refchip-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex: none;
  background: var(--ink-3);
}
.refchip.protocol .refchip-dot,
.refchip-dot.protocol {
  background: var(--accent);
}
.refchip.knowledge .refchip-dot,
.refchip-dot.knowledge {
  background: var(--warning);
}
.refchip.structure .refchip-dot,
.refchip-dot.structure {
  background: var(--success);
}
.refchip.active {
  border-color: var(--accent);
  background: var(--accent-tint);
  box-shadow: 0 0 0 1px var(--accent-tint-2);
  font-weight: 600;
}
.refs-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 11px;
}
.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--ink-2);
}
.prov-caption {
  margin: 14px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--ink-2);
}

/* ---- Estimate line --------------------------------------------------- */
.estimate {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  color: var(--ink-2);
  margin-bottom: 16px;
}

/* ---- Pipeline (preview + live) --------------------------------------- */
.pipeline {
  margin-top: 14px;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  overflow: hidden;
}
.pipe-step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  font-size: 14px;
}
.pipe-step + .pipe-step {
  border-top: 1px solid var(--hair);
}
.pipe-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex: none;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 600;
  border: 1.5px solid var(--border-strong);
  color: var(--ink-3);
  background: var(--surface);
}
.pipe-step.done .pipe-dot {
  background: var(--success);
  border-color: var(--success);
  color: #fff;
}
.pipe-step.running {
  background: var(--accent-tint);
}
.pipe-step.running .pipe-dot {
  border-color: var(--accent);
  color: var(--accent);
}
.pipe-step.error .pipe-dot {
  border-color: var(--danger);
  color: var(--danger);
}
.pipe-label {
  flex: 1;
}
.pipe-step.running .pipe-label {
  font-weight: 600;
}
.pipe-step.pending .pipe-label {
  color: var(--ink-3);
}
.pipe-meta {
  font-size: 12px;
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
}

/* ---- Download cards -------------------------------------------------- */
.downloads {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}
.dl-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  background: var(--surface);
}
.dl-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--r);
  flex: none;
  background: var(--accent-tint);
  color: var(--accent);
  display: grid;
  place-items: center;
}
.dl-meta {
  min-width: 0;
  flex: 1;
}
.dl-title {
  font-size: 14.5px;
  font-weight: 600;
  color: var(--ink);
}
.dl-sub {
  font-size: 12.5px;
  color: var(--ink-3);
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dl-card .btn {
  flex: none;
}

/* ---- Login ----------------------------------------------------------- */
.login-wrap {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--canvas);
}
.login-card {
  width: 100%;
  max-width: 400px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--depth-16);
  padding: 40px 36px 32px;
  text-align: center;
}
.login-brand {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.02em;
  margin-bottom: 4px;
}
.login-brand .dot {
  color: var(--accent);
}
.login-tag {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-3);
  margin-bottom: 20px;
}
.login-card p.blurb {
  color: var(--ink-2);
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 26px;
}
.gbtn-holder {
  display: flex;
  justify-content: center;
  min-height: 44px;
}
.login-foot {
  margin-top: 26px;
  font-size: 12px;
  color: var(--ink-3);
}

/* ---- Loading -------------------------------------------------------- */
.center-spinner {
  min-height: 100vh;
  display: grid;
  place-items: center;
  color: var(--accent);
}
.spin {
  animation: spin 0.9s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 var(--accent-tint);
  }
  50% {
    box-shadow: 0 0 0 5px var(--accent-tint);
  }
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}

@media (max-width: 640px) {
  .step .lbl {
    display: none;
  }
  .workspace {
    padding: 20px 16px 64px;
  }
  .matter-chip {
    max-width: 40vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/webapp/styles.css"],"names":[],"mappings":"AAAA;;;+EAG+E;AAC/E;EACE,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,8EAA8E;EAC9E,8EAA8E;EAC9E,+EAA+E;EAC/E,iFAAiF;EACjF,iBAAiB;EACjB;gCAC8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;;EAEE,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gDAAgD;AAClD;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;;EAGE,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,uCAAuC;EACvC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA,2EAA2E;AAC3E;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,4DAA4D;EAC5D,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,iEAAiE;AACnE;AACA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,0CAA0C;EAC1C,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;EACjC,+BAA+B;EAC/B,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA,2EAA2E;AAC3E;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;;IAEE,sCAAsC;EACxC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ==========================================================================\n   Suade workspace — Office-native (Fluent 2) design system, light theme.\n   Bespoke, dependency-free. All component styling flows from these tokens.\n   ========================================================================== */\n:root {\n  /* neutrals (Fluent warm-gray bias) */\n  --canvas: #faf9f8;\n  --surface: #ffffff;\n  --surface-alt: #f7f6f4;\n  --surface-sunken: #f3f2f1;\n  --hair: #edebe9;\n  --border: #e1dfdd;\n  --border-strong: #d2d0ce;\n  --ink: #242424;\n  --ink-2: #605e5c;\n  --ink-3: #8a8886;\n  --ink-disabled: #a19f9d;\n  /* accent — communication blue */\n  --accent: #0f6cbd;\n  --accent-hover: #115ea3;\n  --accent-pressed: #0c3b5e;\n  --accent-tint: #eff6fc;\n  --accent-tint-2: #e5f1fb;\n  /* semantics */\n  --success: #0e700e;\n  --success-bg: #dff6dd;\n  --warning: #9d5d00;\n  --warning-bg: #fff4ce;\n  --warning-border: #f6e8b8;\n  --danger: #c50f1f;\n  --danger-bg: #fde7e9;\n  --danger-border: #f3d0d4;\n  /* elevation */\n  --depth-2: 0 0.6px 1.8px rgba(0, 0, 0, 0.1), 0 0.1px 0.5px rgba(0, 0, 0, 0.08);\n  --depth-4: 0 1.6px 3.6px rgba(0, 0, 0, 0.13), 0 0.3px 0.9px rgba(0, 0, 0, 0.1);\n  --depth-8: 0 3.2px 7.2px rgba(0, 0, 0, 0.13), 0 0.6px 1.8px rgba(0, 0, 0, 0.11);\n  --depth-16: 0 6.4px 14.4px rgba(0, 0, 0, 0.13), 0 1.2px 3.6px rgba(0, 0, 0, 0.11);\n  /* type + shape */\n  --font: \"Segoe UI Variable Text\", \"Segoe UI\", -apple-system, BlinkMacSystemFont, system-ui, Roboto,\n    \"Helvetica Neue\", sans-serif;\n  --r: 4px;\n  --r-lg: 8px;\n}\n\n* {\n  box-sizing: border-box;\n}\nhtml,\nbody {\n  margin: 0;\n}\nbody {\n  background: var(--canvas);\n  color: var(--ink);\n  font-family: var(--font);\n  font-size: 14px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 1px;\n  border-radius: 2px;\n}\n::selection {\n  background: var(--accent-tint-2);\n}\n\n/* ---- App shell / command bar ----------------------------------------- */\n.appbar {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--hair);\n}\n.appbar-l {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n.brand {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  white-space: nowrap;\n}\n.brand .dot {\n  color: var(--accent);\n}\n.matter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 28px;\n  padding: 0 12px;\n  max-width: 46vw;\n  background: var(--accent-tint);\n  color: var(--accent-pressed);\n  border: 1px solid var(--accent-tint-2);\n  border-radius: 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n}\n.matter-chip .txt {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.appbar-r {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--ink-2);\n  font-size: 13px;\n}\n.appbar-r .who {\n  max-width: 22vw;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.iconbtn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: var(--r);\n  background: transparent;\n  color: var(--ink-2);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n.iconbtn:hover {\n  background: var(--surface-alt);\n}\n.avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  flex: none;\n  background: var(--accent);\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  overflow: hidden;\n}\n.avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.link-btn {\n  border: none;\n  background: none;\n  color: var(--ink-2);\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: var(--r);\n}\n.link-btn:hover {\n  background: var(--surface-alt);\n  color: var(--ink);\n}\n\n.workspace {\n  max-width: 940px;\n  margin: 0 auto;\n  padding: 24px 24px 80px;\n}\n\n/* ---- Step rail ------------------------------------------------------- */\n.steprail {\n  display: flex;\n  align-items: center;\n  margin: 4px 0 22px;\n}\n.step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.step .num {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  flex: none;\n  display: grid;\n  place-items: center;\n  font-size: 12.5px;\n  font-weight: 600;\n  background: var(--surface);\n  border: 1.5px solid var(--border-strong);\n  color: var(--ink-3);\n}\n.step .lbl {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink-3);\n}\n.step.done .num {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n.step.done .lbl {\n  color: var(--ink-2);\n}\n.step.active .num {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: var(--accent-tint);\n}\n.step.active .lbl {\n  color: var(--ink);\n}\n.step-sep {\n  flex: 1;\n  height: 1.5px;\n  min-width: 20px;\n  background: var(--hair);\n  margin: 0 14px;\n}\n.step-sep.done {\n  background: var(--accent);\n}\n\n/* ---- Cards ----------------------------------------------------------- */\n.card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--r-lg);\n  box-shadow: var(--depth-4);\n  padding: 22px 24px;\n  margin-bottom: 16px;\n  animation: rise 0.22s ease both;\n}\n@keyframes rise {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n}\n.card h2 {\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin: 0 0 2px;\n}\n.card .sub {\n  margin: 0 0 18px;\n  color: var(--ink-2);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* ---- Pivot tabs ------------------------------------------------------ */\n.tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--hair);\n  margin-bottom: 20px;\n}\n.tab {\n  position: relative;\n  border: none;\n  background: none;\n  padding: 10px 12px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink-2);\n  cursor: pointer;\n}\n.tab:hover {\n  color: var(--ink);\n}\n.tab.active {\n  color: var(--accent);\n}\n.tab.active::after {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  bottom: -1px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--accent);\n}\n\n/* ---- Fields ---------------------------------------------------------- */\nlabel.field {\n  display: block;\n  margin-bottom: 16px;\n}\nlabel.field .lbl {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink);\n  margin-bottom: 6px;\n}\nlabel.field .hint {\n  font-weight: 400;\n  color: var(--ink-3);\n}\ninput[type=\"text\"],\nselect,\ntextarea {\n  width: 100%;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--r);\n  font: inherit;\n  font-size: 14px;\n  color: var(--ink);\n  background: var(--surface);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\ntextarea {\n  height: auto;\n  min-height: 78px;\n  padding: 8px 10px;\n  line-height: 1.5;\n  resize: vertical;\n}\ninput[type=\"text\"]::placeholder,\ntextarea::placeholder {\n  color: var(--ink-3);\n}\ninput[type=\"text\"]:hover,\nselect:hover,\ntextarea:hover {\n  border-color: var(--ink-3);\n}\ninput[type=\"text\"]:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 1px var(--accent);\n}\n.select-wrap {\n  position: relative;\n}\n.select-wrap select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 32px;\n}\n.select-wrap .chev {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--ink-2);\n  pointer-events: none;\n}\n.inline-field {\n  display: flex;\n  gap: 10px;\n  align-items: stretch;\n}\n\n/* ---- Buttons --------------------------------------------------------- */\n.btn {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0 16px;\n  border: 1px solid transparent;\n  border-radius: var(--r);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n.btn.lg {\n  height: 38px;\n  padding: 0 20px;\n  font-size: 15px;\n}\n.btn.primary {\n  background: var(--accent);\n  color: #fff;\n}\n.btn.primary:hover {\n  background: var(--accent-hover);\n}\n.btn.primary:active {\n  background: var(--accent-pressed);\n}\n.btn.secondary {\n  background: var(--surface);\n  color: var(--ink);\n  border-color: var(--border-strong);\n}\n.btn.secondary:hover {\n  background: var(--surface-alt);\n}\n.btn.subtle {\n  background: transparent;\n  color: var(--accent);\n}\n.btn.subtle:hover {\n  background: var(--accent-tint);\n}\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.btn-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n/* ---- Banners --------------------------------------------------------- */\n.banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: var(--r);\n  font-size: 13px;\n  line-height: 1.45;\n  border: 1px solid;\n}\n.banner svg {\n  flex: none;\n}\n.banner.info {\n  background: var(--accent-tint);\n  border-color: var(--accent-tint-2);\n  color: var(--accent-pressed);\n}\n.banner.warn {\n  background: var(--warning-bg);\n  border-color: var(--warning-border);\n  color: var(--warning);\n}\n.banner.error {\n  background: var(--danger-bg);\n  border-color: var(--danger-border);\n  color: var(--danger);\n}\n.error-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: var(--r);\n  font-size: 13px;\n  color: var(--danger);\n  background: var(--danger-bg);\n  border: 1px solid var(--danger-border);\n  margin-top: 14px;\n}\n\n/* ---- Dropzone -------------------------------------------------------- */\n.dropzone {\n  border: 1.5px dashed var(--border-strong);\n  border-radius: var(--r-lg);\n  padding: 26px;\n  text-align: center;\n  color: var(--ink-2);\n  font-size: 14px;\n  background: var(--surface-alt);\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n.dropzone:hover {\n  border-color: var(--ink-3);\n}\n.dropzone.drag {\n  border-color: var(--accent);\n  background: var(--accent-tint);\n}\n.dropzone .dz-icon {\n  color: var(--accent);\n  margin-bottom: 8px;\n}\n.dropzone strong {\n  color: var(--accent);\n  font-weight: 600;\n}\n.dropzone .dz-sub {\n  font-size: 12px;\n  color: var(--ink-3);\n  margin-top: 6px;\n}\n.dropzone .dz-busy {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--ink-2);\n}\n\n/* ---- Classification summary ------------------------------------------ */\n.matter-facts {\n  font-size: 13.5px;\n  color: var(--ink-2);\n  line-height: 1.5;\n  margin: 4px 0 12px;\n}\n.matter-facts b {\n  color: var(--ink);\n  font-weight: 600;\n}\n.summary-line {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 14px 0 10px;\n}\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.chip {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  padding: 5px 11px;\n  border-radius: 6px;\n  background: var(--accent-tint);\n  color: var(--accent-pressed);\n  border: 1px solid var(--accent-tint-2);\n  font-size: 12.5px;\n  font-weight: 500;\n}\n.chip b {\n  font-size: 13.5px;\n  font-weight: 600;\n}\n.filelist {\n  margin: 14px 0 0;\n  padding: 0;\n  list-style: none;\n  border: 1px solid var(--border);\n  border-radius: var(--r-lg);\n  overflow: hidden;\n}\n.filelist li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: var(--ink);\n}\n.filelist li + li {\n  border-top: 1px solid var(--hair);\n}\n.filelist .fl-icon {\n  color: var(--ink-3);\n  flex: none;\n}\n.filelist .fl-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.filelist .cat {\n  color: var(--ink-2);\n  font-size: 12px;\n  text-transform: capitalize;\n  background: var(--surface-sunken);\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n.note {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12.5px;\n  color: var(--warning);\n  background: var(--warning-bg);\n  border: 1px solid var(--warning-border);\n  border-radius: var(--r);\n  padding: 9px 12px;\n  margin-top: 12px;\n}\n.note svg {\n  flex: none;\n}\n\n/* ---- Provenance graph ------------------------------------------------ */\n.provenance {\n  border: 1px solid var(--hair);\n  border-radius: var(--r-lg);\n  background: linear-gradient(180deg, #fdfdfc, var(--surface));\n  padding: 18px 20px 16px;\n  margin: 6px 0 8px;\n}\n.prov-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n  margin-bottom: 16px;\n}\n.prov-title {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--accent-pressed);\n}\n.prov-stats {\n  font-size: 12.5px;\n  color: var(--ink-2);\n}\n.prov-stats b {\n  color: var(--ink);\n  font-weight: 600;\n}\n.prov-rail {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 2px 6px;\n  overflow-x: auto;\n}\n.prov-rail::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  right: 4px;\n  top: 11px;\n  height: 2px;\n  background: var(--border-strong);\n  z-index: 0;\n}\n.rail-node {\n  position: relative;\n  z-index: 1;\n  flex: none;\n}\n.rail-dot {\n  display: block;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: var(--surface);\n  border: 2px solid var(--border-strong);\n  transition: border-color 0.15s, background 0.15s, transform 0.15s;\n}\n.rail-node:hover .rail-dot {\n  border-color: var(--accent);\n  transform: scale(1.25);\n}\n.rail-node.first .rail-dot {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n.rail-node.done .rail-dot {\n  background: var(--success);\n  border-color: var(--success);\n}\n.rail-node.running .rail-dot {\n  background: var(--accent);\n  border-color: var(--accent);\n  box-shadow: 0 0 0 4px var(--accent-tint);\n  animation: pulse 1.3s ease-in-out infinite;\n}\n.rail-node.skipped .rail-dot {\n  border-style: dashed;\n}\n.rail-node.error .rail-dot {\n  background: var(--danger);\n  border-color: var(--danger);\n}\n.rail-tip {\n  position: absolute;\n  bottom: 22px;\n  left: 50%;\n  transform: translateX(-50%) translateY(4px);\n  white-space: nowrap;\n  background: var(--ink);\n  color: #fff;\n  font-size: 11.5px;\n  padding: 4px 8px;\n  border-radius: var(--r);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s, transform 0.15s;\n  z-index: 5;\n  box-shadow: var(--depth-8);\n}\n.rail-node:hover .rail-tip {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n.rail-arrow {\n  color: var(--ink-3);\n  z-index: 1;\n  flex: none;\n  display: inline-flex;\n}\n.rail-out {\n  z-index: 1;\n  flex: none;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  background: var(--surface-sunken);\n  border: 1px solid var(--border);\n  border-radius: var(--r);\n  padding: 6px 12px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--ink-2);\n  line-height: 1.35;\n}\n.prov-join {\n  width: 2px;\n  height: 14px;\n  background: var(--border-strong);\n  margin: 2px 0 0 24px;\n}\n.prov-refs {\n  border: 1px dashed var(--border-strong);\n  border-radius: var(--r-lg);\n  padding: 12px 14px;\n  background: #fbfcfd;\n}\n.refs-label {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--ink-2);\n  margin-bottom: 10px;\n}\n.refs-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.refchip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 5px 10px;\n  font-size: 12.5px;\n  color: var(--ink);\n  cursor: default;\n  transition: border-color 0.15s, background 0.15s;\n}\n.refchip-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex: none;\n  background: var(--ink-3);\n}\n.refchip.protocol .refchip-dot,\n.refchip-dot.protocol {\n  background: var(--accent);\n}\n.refchip.knowledge .refchip-dot,\n.refchip-dot.knowledge {\n  background: var(--warning);\n}\n.refchip.structure .refchip-dot,\n.refchip-dot.structure {\n  background: var(--success);\n}\n.refchip.active {\n  border-color: var(--accent);\n  background: var(--accent-tint);\n  box-shadow: 0 0 0 1px var(--accent-tint-2);\n  font-weight: 600;\n}\n.refs-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 11px;\n}\n.legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: var(--ink-2);\n}\n.prov-caption {\n  margin: 14px 0 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--ink-2);\n}\n\n/* ---- Estimate line --------------------------------------------------- */\n.estimate {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13.5px;\n  color: var(--ink-2);\n  margin-bottom: 16px;\n}\n\n/* ---- Pipeline (preview + live) --------------------------------------- */\n.pipeline {\n  margin-top: 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--r-lg);\n  overflow: hidden;\n}\n.pipe-step {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 14px;\n  font-size: 14px;\n}\n.pipe-step + .pipe-step {\n  border-top: 1px solid var(--hair);\n}\n.pipe-dot {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  flex: none;\n  display: grid;\n  place-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1.5px solid var(--border-strong);\n  color: var(--ink-3);\n  background: var(--surface);\n}\n.pipe-step.done .pipe-dot {\n  background: var(--success);\n  border-color: var(--success);\n  color: #fff;\n}\n.pipe-step.running {\n  background: var(--accent-tint);\n}\n.pipe-step.running .pipe-dot {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n.pipe-step.error .pipe-dot {\n  border-color: var(--danger);\n  color: var(--danger);\n}\n.pipe-label {\n  flex: 1;\n}\n.pipe-step.running .pipe-label {\n  font-weight: 600;\n}\n.pipe-step.pending .pipe-label {\n  color: var(--ink-3);\n}\n.pipe-meta {\n  font-size: 12px;\n  color: var(--ink-3);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---- Download cards -------------------------------------------------- */\n.downloads {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 20px;\n}\n.dl-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--r-lg);\n  background: var(--surface);\n}\n.dl-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--r);\n  flex: none;\n  background: var(--accent-tint);\n  color: var(--accent);\n  display: grid;\n  place-items: center;\n}\n.dl-meta {\n  min-width: 0;\n  flex: 1;\n}\n.dl-title {\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--ink);\n}\n.dl-sub {\n  font-size: 12.5px;\n  color: var(--ink-3);\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dl-card .btn {\n  flex: none;\n}\n\n/* ---- Login ----------------------------------------------------------- */\n.login-wrap {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: var(--canvas);\n}\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--depth-16);\n  padding: 40px 36px 32px;\n  text-align: center;\n}\n.login-brand {\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  margin-bottom: 4px;\n}\n.login-brand .dot {\n  color: var(--accent);\n}\n.login-tag {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  margin-bottom: 20px;\n}\n.login-card p.blurb {\n  color: var(--ink-2);\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0 0 26px;\n}\n.gbtn-holder {\n  display: flex;\n  justify-content: center;\n  min-height: 44px;\n}\n.login-foot {\n  margin-top: 26px;\n  font-size: 12px;\n  color: var(--ink-3);\n}\n\n/* ---- Loading -------------------------------------------------------- */\n.center-spinner {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  color: var(--accent);\n}\n.spin {\n  animation: spin 0.9s linear infinite;\n}\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 var(--accent-tint);\n  }\n  50% {\n    box-shadow: 0 0 0 5px var(--accent-tint);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n  }\n}\n\n@media (max-width: 640px) {\n  .step .lbl {\n    display: none;\n  }\n  .workspace {\n    padding: 20px 16px 64px;\n  }\n  .matter-chip {\n    max-width: 40vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
